export default "__VITE_ASSET__CVUGWwq8__"